// @flow
// This module is written in CJS so that it can be used on the server-side
// without transpiling.

const ACCESSIBILITY_TESTING_MOUNT_POINT = 'accessibility-testing';
const APPS_PAGES_MOUNT_POINT = 'apps';
const COMPANIES_PAGES_MOUNT_POINT = 'companies';
const CUSTOMERS_PAGES_MOUNT_POINT = 'customers';
const EXPLORE_PAGES_MOUNT_POINT = 'explore';
const HELPDOCS_MOUNT_POINT = 'help';
const HOMEPAGE_MOUNT_POINT = 'home';
const HOW_IT_WORKS_MOUNT_POINT = 'how-it-works';
const PARTNER_MOUNT_POINT = 'partner';
const PATHS_MOUNT_POINT = 'paths';
const PLATFORM_CONTENT_SITE_MOUNT_POINT = 'platform';
const PRESS_PAGES_MOUNT_POINT = 'press';
const PRICING_PAGES_MOUNT_POINT = 'pricing';
const PRIVACY_PAGE_MOUNT_POINT = 'privacy';
const SANDBOX_MOUNT_POINT = 'sandbox';
const SECURITY_MOUNT_POINT = 'security';
const SHARING_MOUNT_POINT = 'shared-ssr';
const USE_CASES_MOUNT_POINT = 'use-cases';

const ZAPIER_ADMIN_URL = (() => {
  const PROD = 'https://admin.zapier.com';
  const DEV = 'http://localhost:8000';
  return process.env.NODE_ENV === 'production' ? PROD : DEV;
})();
const FACEBOOK_PAGE_ID = (() => {
  const PROD = '309796912374932';
  const DEV = '309796912374932'; // No DEV exists yet
  return process.env.NODE_ENV === 'production' ? PROD : DEV;
})();
const FACEBOOK_PAGE_SLUG = (() => {
  const PROD = 'ZapierApp';
  const DEV = 'ZapierApp'; // No DEV exists yet
  return process.env.NODE_ENV === 'production' ? PROD : DEV;
})();
const TWITTER_SLUG = 'zapier';
const GOOGLE_TAG_MANAGER_ID = (() => {
  const PROD = 'GTM-K7GFJTV';
  const DEV = 'GTM-PD8S23G';
  return process.env.NODE_ENV === 'production' ? PROD : DEV;
})();
const GOOGLE_OPTIMIZE_ID = 'GTM-PKHGGSG';
const GOOGLE_SITE_VERIFICATION_ID =
  'Mplw0unXm1SQzihRuuBFgiBxjBXgfRw64bSZCfEUhlw';
const POCKET_SITE_VERIFICATION_ID = 'e3616a9b06fea1f1ec3cc8180f2a68';
const AHREFS_SITE_VERIFICATION_ID =
  'c3e3e278ca04ba3706e232a770f736b282492961b65f6f05181c921e41c4eba8';

const INVALID_IMAGE_CDN_URLS = ['cdn.zapier.com', 'zapier.cachefly.net'];
const IMAGE_SERVICE_URL = 'images.zapier.com';

const DEVELOPER_PLATFORM_DOC_URL = 'https://platform.zapier.com';

const IMGIX_HOST = 'zapier-images.imgix.net';

// todo(ibolmo): Figure out a way to move this to packages/ssr-server
const X_FRAME_EXEMPT = {
  // use if the route is safe even in a malicious embed (we will skip checking if the
  // embedder is permitted)
  ALWAYS: 'always',
  // use if the route is permitted to be embedded. we will still check
  // if the embedder is permitted (whitelisted)
  EXEMPT: 'exempt',
};

// See https://docs.datadoghq.com/real_user_monitoring/installation/?tab=us#initialization-parameters
const DATADOG_RUM_CONFIG = {
  clientToken: 'pub34f37b767b492f56ae0f6a96fd8366dd',
  applicationId: '0ba71a62-0fd6-4978-9068-2334ebbab924',
  resourceSampleRate: 100,
  sampleRate: 10,
};

module.exports = {
  ACCESSIBILITY_TESTING_MOUNT_POINT,
  AHREFS_SITE_VERIFICATION_ID,
  APPS_PAGES_MOUNT_POINT,
  COMPANIES_PAGES_MOUNT_POINT,
  CUSTOMERS_PAGES_MOUNT_POINT,
  DATADOG_RUM_CONFIG,
  DEVELOPER_PLATFORM_DOC_URL,
  EXPLORE_PAGES_MOUNT_POINT,
  FACEBOOK_PAGE_ID,
  FACEBOOK_PAGE_SLUG,
  GOOGLE_OPTIMIZE_ID,
  GOOGLE_SITE_VERIFICATION_ID,
  GOOGLE_TAG_MANAGER_ID,
  HELPDOCS_MOUNT_POINT,
  HOMEPAGE_MOUNT_POINT,
  HOW_IT_WORKS_MOUNT_POINT,
  IMAGE_SERVICE_URL,
  IMGIX_HOST,
  INVALID_IMAGE_CDN_URLS,
  PARTNER_MOUNT_POINT,
  PATHS_MOUNT_POINT,
  PLATFORM_CONTENT_SITE_MOUNT_POINT,
  POCKET_SITE_VERIFICATION_ID,
  PRESS_PAGES_MOUNT_POINT,
  PRICING_PAGES_MOUNT_POINT,
  PRIVACY_PAGE_MOUNT_POINT,
  SANDBOX_MOUNT_POINT,
  SECURITY_MOUNT_POINT,
  SHARING_MOUNT_POINT,
  USE_CASES_MOUNT_POINT,
  TWITTER_SLUG,
  X_FRAME_EXEMPT,
  ZAPIER_ADMIN_URL,
};
